<template>
    <v-row class="fill-height">
        <v-col>
            <v-card>
                <v-card-title>
                    <v-icon left>mdi-view-list-outline</v-icon>
                    Cobranças
                    <v-spacer></v-spacer>
                    <v-text-field
                        v-model="paginationOptions.search"
                        class="mr-3"
                        append-icon="mdi-magnify"
                        label="Buscar"
                        placeholder="Informe o Nome do Serviço"
                        single-line
                        hide-details
                        @keydown="buscar()"
                        @click:append="buscar()"
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <!--                    <v-switch-->
                    <!--                        v-model="charges.active"-->
                    <!--                        :label=" `Exibindo ${charges.active? 'Ativos': 'Inativos'}`"-->
                    <!--                        single-line-->
                    <!--                        hide-details-->
                    <!--                        class="mr-3"-->
                    <!--                        style="width: 200px"-->
                    <!--                        @change="buscar()"-->
                    <!--                    ></v-switch>-->

                    <!--                    <v-btn-->
                    <!--                        class="btn-new"-->
                    <!--                        :to="{ name: 'servicesCreate' }"-->
                    <!--                    >-->
                    <!--                        <v-icon left>mdi-plus</v-icon>-->
                    <!--                        Adicionar-->
                    <!--                    </v-btn>-->
                </v-card-title>
                <v-alert type="warning" outlined v-show="!charges.items"
                >Nenhum Movimento Encontrado
                </v-alert
                >
                <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="filteredChargesItems()"
                    :options.sync="options"
                    :server-items-length="charges.totalItems"
                    :search.sync="paginationOptions.search"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    item-key="id"
                    class="elevation-1"
                    v-show="charges.items"
                    :footer-props="{
                        'items-per-page-options': [10, 25, 50, 75, 100]
                      }"
                >
                    
                    <template v-slot:item.canceled="{ item }">
                        <v-icon v-if="item.statusID == statusWaitingPayment" color="purple darken-1">mdi-cash-clock</v-icon>
                        <v-icon v-if="item.statusID == statusPaid" color="green darken-1">mdi-check-circle-outline</v-icon>
                        <v-icon v-if="item.canceled || item.statusID == statusCanceled" color="red darken-1">mdi-close-circle-outline</v-icon>
                    </template>
                    <template v-slot:item.comanda="{ item }">
                        <span :color="comandaColor(item.statusID)" > {{ item.comanda}}</span>
                    </template>
                    <template v-slot:item.value="{ item }">
                        {{ item.value | money }}
                    </template>
                    <template v-slot:item.discount="{ item }">
                        {{ item.discount | money }}
                    </template>
                    <template v-slot:item.totalValue="{ item }">
                        {{ item.totalValue | money }}
                    </template>
                    <template v-slot:item.createdAt="{ item }">
                        {{ item.createdAt | formatDate3 }}
                    </template>

                    <template v-slot:item.actions="{ item }">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    icon
                                    class="btn-lyndus"
                                    v-bind="attrs"
                                    v-on="on"
                                    :to="{ name: 'charge', params: { id: item.id } }"
                                >
                                    <v-icon>mdi-eye</v-icon>
                                </v-btn>
                            </template>
                            <span>Visualizar</span>
                        </v-tooltip>
                    </template>
                </v-data-table>
            </v-card>
        </v-col>
    </v-row>

</template>

<script>
import {mask} from "vue-the-mask";
import {mapGetters} from "vuex";
import store from "@/store";

import {CHANGE_PROGRESS} from "@/store/mutations/mutations.type";

import { FINANCE_CREATE
} from "@/store/actions/financial.type";

import {CHARGE_RESET_STATE, SET_CHARGE_PAGINATION} from "@/store/mutations/charge.type";
import {CHARGE_SEARCH} from "@/store/actions/charge.type";

export default {
    name: "financial",
    directives: {mask},
    components: {},
    async beforeRouteUpdate(to, from, next) {
        // Reset state if user goes from /editor/:id to /editor
        // The component is not recreated so we use to hook to reset the state.
        await store.commit(CHARGE_RESET_STATE);
        return next();
    },
    async beforeRouteEnter(to, from, next) {
        await store.commit(CHARGE_RESET_STATE);
        // await store.dispatch(CHARGE_SEARCH);

        return next();
    },
    async beforeDestroy() {
        if(!this.$route.path.includes('/charge')){
            localStorage.removeItem('chargeOptions')
            localStorage.removeItem('chargePaginationOptions')
        }
    },
    data: () => ({
        textRules: [
            (v) => !!v || "Este campo é obrigatório",
            //v => v > 0 || "Esta campo deve ter um valor maior que zero."
        ],
        statusWaitingPayment: 2,
        statusPaid: 3,
        statusCanceled: 4,
        
        sortBy: 'createdAt',
        sortDesc: true,
        selected: [],
        options: {},
        paginationOptions: {search: ''},
        headers: [
            {text: "", align: "left", value: "canceled", sortable: false},
            {text: "Comanda", align: "left", value: "comanda"},
            {text: "Pessoa", value: "personName"},
            {text: "Valor", value: "value"},
            {text: "Desconto", value: "discount"},
            {text: "Valor Total", value: "totalValue"},
            {text: "Data", value: "createdAt"},
            {text: "Visualizar", value: "actions", sortable: false}
        ],
        tab: null,
        bankAccountIndex: null,
        localBanks: [],
        search: null,
        balanceRequestValue: 0,
        balanceRequest: {
            value: 0,
            valueReleased: 0,
            valueToReleased: 0,
            valueTotal: 0,
            valueRate: 0,
            bankID: 0
        },

        formIsValid: false,
        optionsMoney: {
            locale: "pt-BR",
            prefix: "R$:",
            length: 9,
            precision: 2
        },
        active: false,
        btnBalanceCheck: true,

        dialogRescueBalance: false,
        dialogBalance: false,
        dialogBankAccount: false,


        dialogBankRemove: false,
        socialEdit: false,
        updateLogo: null,


        social: {
            socialID: 0,
            url: "",
        },

        balance: {
            socialID: 0,
            url: "",
        },
        subtitle: {
            socialID: 0,
            url: "",
        },

        pixRules: [
            v => !!v && !!this.bankAccount.bank && this.bankAccount.agency && this.bankAccount.account || "Este campo é obrigatório"
            //v => v > 0 || "Esta campo deve ter um valor maior que zero."
        ],


    }),

    methods: {
        rescueRules(v) {
            let n = parseFloat(v.replace(".", "").replace(",", "."))
            if (isNaN(n)) return "Informe um valor válido ";

            if (n < 1) return "O Valor Mínimo é de R$ 1,00";

            if (this.finance.balanceTotal < n) return "O Valor informado é maior que o Saldo Total";

            return true
        },
        bankRulesValid(v) {
            if (!this.bankAccount.chavePIX) {
                return !!v || "Este campo é obrigatório"
            }
            return true
        },
        pixRulesValid(v) {
            if (!this.bankAccount.bank && !this.bankAccount.agency && !this.bankAccount.account) {
                return !!v || "Este campo é obrigatório"
            }
            return true
        },




        removeBankDialog(id, index) {
            this.dialogBankRemove = true;
            this.bankAccount.id = id
            this.bankAccountIndex = index
        },
        dialogRescueBalanceDialog() {

            this.dialogRescueBalance = true;
            for (let i = 0; i < this.bankAccounts.length; i++) {
                if (this.bankAccounts[i].default) {
                    this.balanceRequest.bankID = this.bankAccounts[i].id
                    return
                }
            }

        },
        loadExtract() {
            this.buscar()
        },
        async buscar() {
            const {sortBy, sortDesc, itemsPerPage, page} = this.options
            this.chargePagination.search = this.paginationOptions.search

            store.commit(SET_CHARGE_PAGINATION, {
                page: page,
                itemsPerPage: itemsPerPage,
                orderBy: sortBy,
                sortDesc: sortDesc[0]
            })
            await store.dispatch(CHARGE_SEARCH);
        },
        filteredChargesItems() { 
            const items = this.charges.items
            const search = this.chargePagination.search ? this.chargePagination.search.toLowerCase() : ""
            if(search){
                this.options.itemsPerPage = this.charges.totalItems
                this.options.page = 1
                const exactMatches = [];
                const partialMatches = [];

                items.forEach(item => {
                    const itemValues = Object.values(item).map(value => String(value).toLowerCase());
                    const isExactMatch = itemValues.some(value => value.startsWith(search));
                    const isPartialMatch = itemValues.some(value => value.includes(search));
                    
                    if (isExactMatch) {
                        exactMatches.push(item);
                    } else if (isPartialMatch) {
                        partialMatches.push(item);
                    }
                });

                return [...exactMatches,...partialMatches];
            }
            else {
                if(this.options.itemsPerPage == this.charges.totalItems){
                    this.options.itemsPerPage = 10
                }
                return items;
            } 
        },
        async rescueBalance() {

            this.dialogRescueBalance = false;

            await this.$store
                .dispatch(FINANCE_CREATE, this.balanceRequest)
                .then(response => {
                    this.$store.commit(CHANGE_PROGRESS, false);

                    this.snackbar.snackbar = true;
                    this.snackbar.color = "success";
                    this.snackbar.text = "Salvo com sucesso";

                    this.$refs.formBalanceRescue.reset()
                    this.$router.push({
                        name: "financialView",
                        params: {id: response.data.id}
                    });
                })
                .catch(({response}) => {
                    this.$store.commit(CHANGE_PROGRESS, false);
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao Salvar";
                    if (typeof response.data.message !== "undefined") {
                        this.snackbar.text =
                            "Erro ao salvar: " + response.data.message;
                    }
                });


        },

        comandaColor(status){
          if (status == this.statusWaitingPayment){
              return "purple darken-1"
          }  else if (status == this.statusPaid){
              return "green darken-1"
          }  else if (status == this.statusCanceled){
              return "red darken-1"
          }
          return ""
        },
        
        //Dialog Balance - Botão Liberar Saldo

        closeBalance() {
            this.$refs.formBalance.resetValidation();
            this.socialEdit = false;
            this.dialogBalance = false;
            this.social.socialID = null;
            this.social.url = "";
        },


        //Dialog Bank Account - Botão Adicionar (Conta)
        closeBankAccount() {
            this.$refs.formBankAccount.resetValidation();
            this.socialEdit = false;
            this.dialogBankAccount = false;
            this.social.socialID = null;
            this.social.url = "";
        },

    },
    mounted() {
        if (localStorage.getItem('chargeOptions')){
            this.options = JSON.parse(localStorage.getItem('chargeOptions'))
        }
        if (localStorage.getItem('chargePaginationOptions')){
            this.paginationOptions = JSON.parse(localStorage.getItem('chargePaginationOptions'))
        }
    },
    watch: {
        search(val) {
            val && val !== this.select && this.querySelections(val)
        },

        options: {
            handler(newOptions) {
                this.buscar()
                const parsed = JSON.stringify(newOptions)
                localStorage.setItem('chargeOptions', parsed)
            },
            deep: true,
        },
        paginationOptions: {
            handler(newSearch) {
                this.buscar()
                const parsed = JSON.stringify(newSearch)
                localStorage.setItem('chargePaginationOptions', parsed)
            },
            deep: true,
        }
    },
    computed: {
        ...
            mapGetters(["snackbar", "charges", "chargePagination"]),
    }
    ,
}
;
</script>